import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  list: {
    paddingBottom: '20px',

    '& ul.ant-list-items': {
      display: 'flex',
      gap: 16
    }
  },

  draggable: {
    '.ant-card': {
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      transform: 'rotate(4deg)',
      boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
      cursor: 'grabbing'
    }
  },

  scrollContainer: {
    overflowY: 'hidden',
    overflowX: 'auto'
  },

  card: {
    width: 290,
    height: '70vh',
    backgroundColor: token.colorBorderSecondary,

    '& .ant-card-body': {
      padding: token.padding
    }
  },

  column: {
    height: 'calc(70vh - 70px)',
    overflowY: 'auto',
    '& ul.ant-list-items': {
      display: 'flex',
      gap: 16
    },

    scrollbarWidth: 'thin',

    '&::-webkit-scrollbar': {
      width: '380px',
      height: '8px'
    },

    '&::-webkit-scrollbar-thumb': {
      background: token.colorWhite,
      borderRadius: '1px'
    }
  },

  columnDroppable: {
    zIndex: 10,
    minHeight: '100%'
  },

  cardContent: {
    padding: '0px 0px 0px 4px',
    marginBottom: '6px'
  },

  collapse: {
    '.ant-collapse-item .ant-collapse-header': {
      padding: 0
    }
  },

  disabledCard: {
    opacity: 0.4,
    pointerEvents: 'none' as const,
    cursor: 'not-allowed'
  },

  kanbanCard: {
    cursor: 'grab',
    '.ant-card-body': {
      padding: '8px 8px 8px 4px'
    },
    '&:hover': {
      '& .ant-card-body > div:first-child > div:first-child > button:last-child':
        {
          opacity: 1
        }
    }
  },

  expandButton: {
    opacity: 0,
    transition: 'opacity 0.2s'
  },

  rate: {
    '&.ant-rate': {
      fontSize: 16
    }
  }
}))
